import { render, staticRenderFns } from "./BoardsList.vue?vue&type=template&id=47dbf978&scoped=true"
import script from "./BoardsList.vue?vue&type=script&lang=js"
export * from "./BoardsList.vue?vue&type=script&lang=js"
import style0 from "./BoardsList.vue?vue&type=style&index=0&id=47dbf978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dbf978",
  null
  
)

export default component.exports